import { memo, useEffect, useRef } from 'react';
import { shallowEqual } from 'react-redux';

import { useAppSelector } from '@/app/store/hooks';
import { selectMultiplierState } from '@/entities/jetton';
import type { CurrencyCode } from '@/shared/lib/currency';
import { CashOutButton as CashOutButtonBase } from '@/shared/ui/CashOutButton';

import { createPayoutPainter } from '../multiplier/painters';
import { useMultiplier } from '../multiplier/useMultiplier';

interface Props {
  amount: number;
  currency: CurrencyCode;
  onCashout: () => void;
}

export const JettonCashOutButton = memo(({ amount, currency, onCashout }: Props) => {
  const { status, startTimeMs, crashMultiplier } = useAppSelector(
    selectMultiplierState,
    shallowEqual,
  );

  const engine = useMultiplier(status, startTimeMs, crashMultiplier);
  const payoutRef = useRef<HTMLSpanElement>(null);

  useEffect(() => {
    const node = payoutRef.current;
    if (node === null) return;
    return engine.subscribe(createPayoutPainter(node, amount, currency));
  }, [engine, amount, currency]);

  return <CashOutButtonBase onClick={onCashout} labelRef={payoutRef} />;
});
